export class NullableDecoder {
    constructor(decoder) {
        this.decoder = decoder;
    }
    decode(data) {
        if (data.value === null) {
            return null;
        }
        return data.decode(this.decoder);
    }
}
//# sourceMappingURL=NullableDecoder.js.map